const EventManager = {
    fireCustomEvent: function (eventName: string, data: any = undefined) {
        let event: Event = new CustomEvent(eventName, { detail: data });
        document.dispatchEvent(event);
    }
};

export { EventManager };


// WEBPACK FOOTER //
// ./src/webportal/services/EventManager.ts